var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPillar4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.9,
    height: 66.3,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M26.5 34.5c7 0 12.7-5.7 12.7-12.7V15H13.7v6.8c0 7.1 5.7 12.7 12.8 12.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6_",
    className: "st0",
    cx: 12.4,
    cy: 55.6,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st0",
    d: "M41.5 36.8v9.5c3.1.5 5.5 3.2 5.5 6.4v6.9c0 .5-.4 1-1 1s-1-.4-1-1v-6.9c0-2.5-2.1-4.6-4.6-4.6s-4.6 2.1-4.6 4.6v6.9c0 .5-.4 1-1 1s-1-.4-1-1v-6.9c0-3.3 2.4-5.9 5.5-6.4V36c-2.2-.8-3.8-1.1-3.8-1.1l-9.3 9.9-9.3-9.9s-1.6.3-3.8 1.1v15.8c1.7.4 3 2 3 3.8 0 2.2-1.8 4-4 4s-4-1.8-4-4c0-1.9 1.3-3.4 3-3.8v-15C6.5 39 0 43.5 0 52v8.8c0 3.8 1.4 5.5 5.5 5.5h42c4.1 0 5.5-1.6 5.5-5.5V52c-.1-8.5-6.5-13-11.5-15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M37.2 2.4C36.9 1.1 35.6 0 34.3 0H18.7c-1.4 0-2.7 1.1-2.9 2.4l-2 10.7h25.4l-2-10.7zM31 8.2h-2.9v2.9h-3.3V8.2h-2.9V4.9h2.9V2h3.3v2.9H31v3.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillar4);
export default __webpack_public_path__ + "static/media/pillar4.7dfbb3e85d5709599d42227dc915635d.svg";
export { ForwardRef as ReactComponent };